  <div *ngIf="paginationConfig.totalCount > 0"
       class="pagination-container">
    <div class="pagination-info">
      Mostrando {{ displayedRange.start }} - {{ displayedRange.end }}
      de {{ paginationConfig.totalCount }} registros
    </div>
    <div class="pagination-controls">
      <button
        mat-icon-button
        [disabled]="isFirstPage || isLoading"
        (click)="previousPage()"
        matTooltip="Página anterior">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="page-indicator">
        Página {{ paginationConfig.currentPage }} de {{ paginationConfig.totalPages }}
      </span>
      <button
        mat-icon-button
        [disabled]="isLastPage || isLoading"
        (click)="nextPage()"
        matTooltip="Página siguiente">
        <mat-icon>chevron_right</mat-icon>
      </button>

      <div *ngIf="showPageSizeSelector && pageSizeOptions && pageSizeOptions.length > 0"
           class="page-size-selector">
        <span>Por página:</span>
        <select
           aria-label="Registros por página"
          (change)="onPageSizeChange($event)"
          [disabled]="isLoading"
          class="page-size-select">
          <option *ngFor="let size of pageSizeOptions"
                  [value]="size"
                  [selected]="size === selectedPageSize">
            {{ size }}
          </option>
        </select>
      </div>
    </div>
  </div>
